// extracted by mini-css-extract-plugin
export var cardTitle = "_jm-1";
export var commentBubble = "_jm-e";
export var commentForm = "_jm-a";
export var commentInput = "_jm-b";
export var commentLabel = "_jm-d";
export var commentPrompt = "_jm-9";
export var csatCard = "_jm-0";
export var feedbackSection = "_jm-7";
export var starDisabled = "_jm-6";
export var starEmpty = "_jm-5";
export var starFilled = "_jm-4";
export var starWrapper = "_jm-3";
export var starsContainer = "_jm-2";
export var submittedComment = "_jm-c";
export var thankYouText = "_jm-8";